module.exports = __webpack_public_path__ + "img/r4.6541b33a.jpg";